<script setup lang="ts">
import { baseUrl, padWithZeros } from '@/core/utils'
import LanguageView from '@/core/components/LanguageView.vue'
import { SAMUDKOY } from '../../constants'
import { useTextPage, useTextPageMock } from './TextPage'

const { page } = useTextPage()
</script>

<template>
  <language-view lang="th">
    <div class="text-page">
      <img class="title" src="/images/simakatra/th/text-page.png" />
      <template v-for="n in SAMUDKOY.NUM_PAGES">
        <img v-show="n == page" class="page" :src="baseUrl(`/images/samudkoy-number/th/p${padWithZeros(n, 2)}.png`)" />
      </template>
    </div>
  </language-view>

  <language-view lang="en">
    <div class="text-page en">
      <img class="title" src="/images/simakatra/en/text-page.png" />
      <template v-for="n in SAMUDKOY.NUM_PAGES">
        <img v-show="n == page" class="page" :src="baseUrl(`/images/samudkoy-number/en/p${padWithZeros(n, 2)}.png`)" />
      </template>
    </div>
  </language-view>
</template>

<style scoped>
.text-page {
  position: absolute;
  left: 294px;
  top: 990px;
}

.title {
  position: absolute;
}

.page {
  position: absolute;
  left: 65px;
}

.text-page.en .title {
  position: absolute;
  left: -12px;
}

.text-page.en .page {
  position: absolute;
  left: 75px;
}
</style>
